export const TASK_CONFIGURATIONS_TABLE_HEADERS = [
	{ label: 'Stage', id: 'stage' },
	{ label: 'SL', id: 'sl' },
	{ label: 'Task', id: 'task' },
	{ label: 'Journey info', id: 'Journey info' },
	{ label: 'Completion condition', id: 'completion_condition' },
	{ label: 'Dependency', id: 'dependency' },
	{ label: 'Who can complete?', id: 'who_can_complete' },
	{ label: 'Not required, if it’s', id: 'not_required_if' },
	{ label: 'Action', id: 'action' }
];

export const TASK_CREATE_INIIAL_STATE = {
	dependencyToggle: false,
	taskName: '',
	stage: null,
	taskPosition: null,
	selectedTaskForPosition: null,
	compleationCondition: null,
	dependency: [],
	whoCanCompleate: [],
	requiredCondition: [],
	taskStatus: { value: 'Active', id: 'ACTIVE' },
	journeys: []
};

export const TASK_POSITIONS_LIST = [
	{ id: 'FIRST_TASK', value: '1st task' },
	{ id: 'AFTER', value: 'After' },
	{ id: 'BEFORE', value: 'Before' }
];

export const TASK_STATUS = [
	{ id: 'ACTIVE', value: 'Active' },
	{ id: 'DISABLED', value: 'Disable' }
];

export const TASK_ENUM = {
	COMPLETION_CONDITION_ENUM: 'info.nitex.app.product.ProductDevelopmentTaskNotRequiredCondition',
	TASK_VALUE_TYPES_ENUM: 'info.nitex.app.product.TaskValueType'
};

export const TASK_CONFIGURATIONS_TAB_ITEMS = [
	{
		id: 'TASK',
		label: 'Task configuration'
	},
	{
		id: 'JOURNEY',
		label: 'Journey configuration'
	},
	{
		id: 'CREATE_LIST',
		label: 'Create list'
	},
	{
		id: 'CREATE_DASHBOARD',
		label: 'Create dashboard'
	},
	{
		id: 'SOP_AND_TUTORIALS',
		label: 'SOP & Tutorials'
	}
];

// Used in task configuration page
export const TAB_LIST = {
	JOURNEY: 'JOURNEY',
	TASK: 'TASK',
	CREATE_LIST: 'CREATE_LIST',
	CREATE_DASHBOARD: 'CREATE_DASHBOARD',
	SOP_AND_TUTORIALS: 'SOP_AND_TUTORIALS'
};

export const FILTER_STATUS = [
	{ id: 'ACTIVE', name: 'Active', value: 'Active', boolean: true },
	{ id: 'DISABLE', name: 'Disable', value: 'Disable', boolean: false }
];

export const DASHBOARD_SECTIONS = [
	{
		id: 'MY_PENDING_TASKS',
		name: 'My Pending Tasks',
		value: 'My Pending Tasks'
	},
	{
		id: 'OTHERS_PENDING_TASKS',
		name: 'Others Pending Tasks',
		value: 'Others Pending Tasks'
	},
	{
		id: 'COMPLETED_TASKS',
		name: 'Completed Tasks',
		value: 'Completed Tasks'
	}
];

export const HEADER_STYLE = [
	{
		id: 'development',
		value: 'development',
		icon: '/icons/dashboard/sample-development.svg',
		textColor: '#1C398E',
		bgColor: '#EFF6FF'
	},
	{
		id: 'order',
		value: 'Order',
		icon: '/icons/dashboard/order.svg',
		textColor: '#59168B',
		bgColor: '#FAF5FF'
	},
	{
		id: 'requisition',
		value: 'Requisition',
		icon: '/icons/dashboard/requisition.svg',
		textColor: '#312C85',
		bgColor: '#EEF2FF'
	},
	{
		id: 'sales',
		value: 'Sales',
		icon: '/icons/dashboard/sales.svg',
		textColor: '#104E64',
		bgColor: '#ECFEFF'
	},
	{
		id: 'costing',
		value: 'Costing',
		icon: '/icons/dashboard/costing.svg',
		textColor: '#0D542B',
		bgColor: '#F0FDF4'
	},
	{
		id: 'issue',
		value: 'Issue',
		icon: '/icons/dashboard/issue.svg',
		textColor: '#82181A',
		bgColor: '#FEF2F2'
	},
	{
		id: 'buyer-request',
		value: 'Buyer-request',
		icon: '/icons/dashboard/buyer.svg',
		textColor: '#7E2A0C',
		bgColor: '#FFF7ED'
	},
	{
		id: 'others',
		value: 'Others',
		icon: '/icons/dashboard/other.svg',
		textColor: '#222222',
		bgColor: '#F0F0F0'
	}
];

export const SOP_LINK_TYPES = [
	{ id: 'SOP_LINK', value: 'SOP Link', name: 'SOP Link' },
	{ id: 'METABASE_REPORT', value: 'Metabase Report', name: 'Metabase Report' },
	{ id: 'TUTORIALS', value: 'Tutorials', name: 'Tutorials' },
	{ id: 'WEBSITE_LINK', value: 'Website Link', name: 'Website Link' },
	{ id: 'OTHERS', value: 'Others', name: 'Others' }
];

export const DASHBOARD_TAB_ITEMS = {
	OTHERS_PENDING_TASK: 'OTHERS_PENDING_TASK',
	COMPLETED_TASK: 'COMPLETED_TASK',
	MY_DASHBOARD_STYLES: 'MY_DASHBOARD_STYLES'
};

export const SEARCH_SORTING_OPTIONS = [
	{ id: 'REQUEST_PRIORITY', value: 'Request priority', name: 'Request priority' },
	{ id: 'MARKET_AND_CATEGORY', value: 'Market & Category', name: 'Market & Category' },
	{ id: 'MARKET_AND_FABRIC', value: 'Market & Fabric', name: 'Market & Fabric' },
	{ id: 'COLLECTION', value: 'Collection name', name: 'Collection name' },
	{ id: 'RECEIVED_BY_PD_DATE', value: 'Received by PD date', name: 'Received by PD date' },
	{ id: 'SEND_TO_PD_DATE', value: 'Send to PD date', name: 'Send to PD date' }
];

export const DASHBOARD_GROUP_BY_IDS = [
	'REQUEST_PRIORITY',
	'MARKET_AND_CATEGORY',
	'MARKET_AND_FABRIC',
	'COLLECTION'
];
